import axios from "axios";
import { useMutation, useQuery } from "react-query";
import { API_URL, securityHeaders } from "../Constants";
import { isEmpty } from "lodash";

const fetchNewsletters = async ({
  pageSize,
  pageNumber,
  selectedActivity,
  searchKey,
}) => {
  return await axios.get(
    // API_URL + `/api/News/GetNewsLetter/${pageSize}/${pageNumber}`,
    API_URL +
      `/api/News/GetNewsLetter/${pageSize}/${pageNumber}${
        !isEmpty(searchKey) ? "?SearchBy=" + searchKey : ""
      }${
        null !== selectedActivity && !isEmpty(searchKey)
          ? "&IsActive=" + selectedActivity
          : null !== selectedActivity && isEmpty(searchKey)
          ? "?IsActive=" + selectedActivity
          : ""
      }`,
    {
      headers: securityHeaders,
    }
  );
};

const deleteNewsletter = (newsId) => {
  return axios.post(
    API_URL + `/api/News/DeleteNewsletter/${newsId}`,
    {},
    {
      headers: securityHeaders,
    }
  );
};

const fetchNewsletterById = async ({ id }) => {
  return await axios.get(API_URL + `/api/News/GetNewsletterById/${id}`, {
    headers: securityHeaders,
  });
};

export const useFetchNewsletters = ({
  pageSize,
  pageNumber,
  selectedActivity,
  searchKey,
}) => {
  return useQuery({
    queryKey: ["newsletters"],
    queryFn: () =>
      fetchNewsletters({ pageSize, pageNumber, selectedActivity, searchKey }),
    enabled: true,
    refetchOnWindowFocus: false,
  });
};

export const useDeleteNewsletter = (newsId) => {
  return useMutation(() => deleteNewsletter(newsId));
};

export const useFetchNewsletterById = ({ id }) => {
  return useQuery({
    queryKey: [`newsletterById-${id}`],
    queryFn: () => fetchNewsletterById({ id }),
    enabled: false,
    refetchOnWindowFocus: false,
  });
};
